import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import SummaryApi from "../common";
import nodata from "../assest/nodata.png";
import { useNavigate } from "react-router-dom";

// ────────────────────────────────────────────────
// THEME — same rules as other files
// ────────────────────────────────────────────────
const THEME = {
  primary: "rgb(23, 44, 87)",
  primaryLight: "rgba(23, 44, 87, 0.08)",
  actionBlue: "#2563EB",
  actionBlueHover: "#1D4ED8",
};

const TeamLeadAllEmpData = () => {
  const [empData, setEmpData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAllEmpData = async () => {
      try {
        const encodedEmployeeId = sessionStorage.getItem(
          "H7Z4L9VD2XK5JW8QRYT6"
        );
        if (!encodedEmployeeId) {
          toast.error("Employee ID not found. Please log in again.");
          setLoading(false);
          return;
        }

        const teamLeadEmpId = atob(encodedEmployeeId);

        const response = await fetch(SummaryApi.getTodayTlAllEmpData.url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer sandeep_university_916",
          },
          body: JSON.stringify({ team_lead_emp_id: teamLeadEmpId }),
        });

        const result = await response.json();

        if (
          result.status &&
          Array.isArray(result.data) &&
          result.data.length > 0
        ) {
          setEmpData(result.data.reverse());
        } else {
          setEmpData([]);
        }
      } catch (err) {
        console.error(err);
        setError("Failed to fetch data.");
      } finally {
        setLoading(false);
      }
    };

    fetchAllEmpData();
  }, []);

  const handleEditClick = async (student) => {
    const responseDetails = await fetch(
      SummaryApi.getStudentDataByStudentId.url,
      {
        method: SummaryApi.getStudentDataByStudentId.method,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer sandeep_university_916",
        },
        body: JSON.stringify({ student_id: student.student_id }),
      }
    );
    const studentData = (await responseDetails.json()).data || null;

    let followUps = [];
    if (student.tl_student_followup_id) {
      const responseFollow = await fetch(
        SummaryApi.getStudentFollowDetails.url,
        {
          method: SummaryApi.getStudentFollowDetails.method,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer sandeep_university_916",
          },
          body: JSON.stringify({
            tl_student_followup_id: student.tl_student_followup_id,
          }),
        }
      );
      const followData = await responseFollow.json();
      followUps = followData.data || [];
    }

    navigate("/my-history", {
      state: {
        student,
        studentDetails: studentData,
        studentFollowUps: followUps,
      },
    });
  };

  if (loading)
    return (
      <div
        className="text-center text-lg font-semibold py-10"
        style={{ color: THEME.primary }}
      >
        Loading employee data...
      </div>
    );

  if (error)
    return (
      <div className="text-center text-red-500 font-semibold py-10">
        {error}
      </div>
    );

  return (
    <div className="min-h-screen">
      <h2
        className="text-2xl font-bold mb-6 "
        style={{ color: THEME.primary }}
      >
        Team Lead All Employee Follow-ups
      </h2>

      <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
        <table className="min-w-full bg-white">
          <thead className="bg-gray-200">
            <tr>
              <th className="px-4 py-2 text-left font-semibold whitespace-nowrap" style={{ color: THEME.primary }}>S.No</th>
              <th className="px-4 py-2 text-left font-semibold whitespace-nowrap" style={{ color: THEME.primary }}>Student Name</th>
              <th className="px-4 py-2 text-left font-semibold whitespace-nowrap" style={{ color: THEME.primary }}>Mobile</th>
              <th className="px-4 py-2 text-left font-semibold whitespace-nowrap" style={{ color: THEME.primary }}>District</th>
              <th className="px-4 py-2 text-left font-semibold whitespace-nowrap" style={{ color: THEME.primary }}>City</th>
              <th className="px-4 py-2 text-left font-semibold whitespace-nowrap" style={{ color: THEME.primary }}>College</th>
              <th className="px-4 py-2 text-left font-semibold whitespace-nowrap" style={{ color: THEME.primary }}>Interested</th>
              <th className="px-4 py-2 text-left font-semibold whitespace-nowrap" style={{ color: THEME.primary }}>Lead By</th>
              <th className="px-4 py-2 text-left font-semibold whitespace-nowrap" style={{ color: THEME.primary }}>Follow-up Date</th>
              <th className="px-4 py-2 text-left font-semibold whitespace-nowrap" style={{ color: THEME.primary }}>Enrolled Date</th>
              <th className="px-4 py-2 text-left font-semibold whitespace-nowrap" style={{ color: THEME.primary }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {empData.length === 0 ? (
              <tr>
                <td
                  colSpan="11"
                  className="text-center py-6 text-gray-500 font-medium"
                >
                  <div className="flex items-center justify-center mb-2">
                    <img
                      src={nodata}
                      alt="No data"
                      className="max-w-full h-auto"
                    />
                  </div>
                  No records for today
                </td>
              </tr>
            ) : (
              empData.map((item, index) => (
                <tr
                  key={item.tl_student_followup_id}
                  className={`${index % 2 === 0 ? "bg-gray-50" : "bg-white"
                    } border-b border-gray-100 hover:bg-slate-50 transition`}
                >
                  <td className="px-4 py-2 text-gray-600">{index + 1}</td>
                  <td className="px-4 py-2 font-medium text-gray-900">{item.student_name}</td>
                  <td className="px-4 py-2">{item.mobile_number1}</td>
                  <td className="px-4 py-2">{item.district}</td>
                  <td className="px-4 py-2">{item.city}</td>
                  <td className="px-4 py-2">{item.clg_name}</td>
                  <td className="px-4 py-2">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-semibold ${item.is_interested === "Most Interested"
                        ? "bg-green-100 text-green-700"
                        : "bg-yellow-100 text-yellow-700"
                        }`}
                    >
                      {item.is_interested}
                    </span>
                  </td>
                  <td className="px-4 py-2 font-medium text-gray-700">
                    {item.employee_name}
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap">
                    {item.followup_next_followup_date_time &&
                      item.followup_next_followup_date_time !== ""
                      ? new Date(
                        item.followup_next_followup_date_time
                      ).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })
                      : "N/A"}
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap">{item.created_date || "N/A"}</td>
                  <td className="py-2 px-4">
                    <button
                      style={{ backgroundColor: THEME.actionBlue }}
                      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = THEME.actionBlueHover)}
                      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = THEME.actionBlue)}
                      className="text-white px-3 py-1.5 rounded-md text-xs font-semibold transition-colors shadow-sm whitespace-nowrap"
                      onClick={() => handleEditClick(item)}
                    >
                      Followup
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TeamLeadAllEmpData;